import { config } from "../config/Config"

export function getYouTubeIdMatchArray(url: string): RegExpMatchArray | null {
  const youtubeIdPattern: RegExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
  return url.match(youtubeIdPattern)
}

export function getSchoolTvIdMatchArray(embedcode: string): RegExpMatchArray | null {
  const schoolTvIdPattern: RegExp = /https:\/\/player\.ntr\.nl\/index\.php\?id=([\w]+)/
  return embedcode.match(schoolTvIdPattern)
}

export function getVimeoIdMatchArray(url: string): RegExpMatchArray | null {
  const vimeoIdPattern: RegExp = /http[s*]:\/\/vimeo.com\/([\d]+)/
  return url.match(vimeoIdPattern)
}

export function isCasperAsset(location: string): boolean {
  return !location.includes("://") && location.includes("casper")
}

export function isCasperAssetId(id: string): boolean {
  const regExp: RegExp =
    /^((\w*-)*casper).(.{4,13}).(([0-9A-Fa-f]{8}[-][0-9A-Fa-f]{4}[-][0-9A-Fa-f]{4}[-][0-9A-Fa-f]{4}[-][0-9A-Fa-f]{12})$)/
  return regExp.test(id)
}

export function getPreviewImage(location: string): string {
  if (isCasperAsset(location)) return getCasperPreviewUrl(location)
  if (isCloudinaryAsset(location)) return getCloudinaryContent(location, "image")
  return location
}

export function isCloudinaryAsset(location?: string): boolean {
  if (!location) return false
  const allowedAssetTypes: string[] = [".png", ".jpg", ".jpeg", ".mp4"]
  return location.includes("/atlas/") && allowedAssetTypes.some((x) => location.includes(x))
}

export function extractCloudinaryAssetId(location: string): string {
  return location.substring(location.lastIndexOf("/") + 1, location.lastIndexOf("."))
}

function getCasperPreviewUrl(assetId: string): string {
  return `${config.assetManagerBaseUrl}/${isCasperAssetId(assetId) ? assetId.split(".").pop() : assetId}`
  // Casper is not used anymore, but we keep the code here for reference
  // if (config.environment === "production")
  //   return `https://damapi-assets.edify.noordhoff.nl/image-output/${assetId}/fontopreview.jpeg`
  // return `https://infinitas-casper-cdn.epublishment.com/image-output/${assetId}/fontopreview.jpeg`
}

export function getCasperOriginalAsset(assetId: string): string {
  return `${config.assetManagerBaseUrl}/${isCasperAssetId(assetId) ? assetId.split(".").pop() : assetId}`
  // Casper is not used anymore, but we keep the code here for reference
  // if (config.environment === "production")
  //   return `https://damapi-assets.edify.noordhoff.nl/document-output/${assetId}/originalasset`
  // return `https://infinitas-casper-cdn.epublishment.com/document-output/${assetId}/originalasset`
}

export function getCasperVideo(assetId: string): string {
  return `${config.assetManagerBaseUrl}/${isCasperAssetId(assetId) ? assetId.split(".").pop() : assetId}`
  // Casper is not used anymore, but we keep the code here for reference
  // if (config.environment === "production")
  //   return `https://damapi-assets.edify.noordhoff.nl/video-output/${assetId}/mp4web/mp4web.mp4`
  // return `https://infinitas-casper-cdn.epublishment.com/video-output/${assetId}/mp4web/mp4web.mp4`
}

export function getCloudinaryContent(url: string, type: "video" | "image"): string {
  if (url.includes("blob:")) return url
  return `https://res.cloudinary.com/${config.cloudinaryCloudName}/${type}/upload/${url}`
}

export function extractPrefix(casperId: string): string {
  const splitted: string[] = casperId.split("-")
  return splitted[splitted.length - 1].substr(0, 5)
}
